import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiActivityService {
  private apiActivitySubject = new Subject<void>();
  apiActivity$ = this.apiActivitySubject.asObservable();

  notifyActivity() {
    this.apiActivitySubject.next();
  }
}
